import { Outlet } from 'react-router-dom';

export const ResetPassword: React.FC = () => {
  return <Outlet />;
};
